<span class="sensitive-data" [attr.data-dd-action-name]="actionName + rowIndex" data-dd-privacy="mask">
  {{ value }}
</span>
